module.exports = __webpack_public_path__ + "media/assets/svgs/menu-white-6355e79f1e687a8ed0210b46331a7a18.svg";